import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from './Footer';
import { ArrowLeft } from 'lucide-react';
type Props = {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
};
export function LegalLayout({
  title,
  lastUpdated,
  children
}: Props) {
  return <div className="min-h-screen bg-bg text-ink font-sans" data-id="element-397">
      {/* Slim header */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-[#F6F4ED]/85 border-b border-line" data-id="element-398">
        <div className="max-w-4xl mx-auto px-6 py-4 flex justify-between items-center" data-id="element-399">
          <Link to="/" className="flex items-center no-underline" data-id="element-400">
            <img src="https://cdn.magicpatterns.com/uploads/fGZPmBEEuygEB5KaVQhdrS/logohorizontal.png" alt="Aurora" className="h-12" data-id="element-401" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-soft hover:text-rose transition-colors no-underline" data-id="element-402">
            <ArrowLeft size={16} data-id="element-403" />
            Voltar para o site
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-16" data-id="element-404">
        <div className="mb-10" data-id="element-405">
          <h1 className="font-serif font-bold text-[clamp(32px,5vw,48px)] tracking-[-0.02em] text-ink leading-tight mb-3" data-id="element-406">
            {title}
          </h1>
          <p className="text-sm text-ink-soft" data-id="element-407">
            Última atualização: {lastUpdated}
          </p>
        </div>

        <article className="legal-prose space-y-6 text-ink" data-id="element-408">{children}</article>
      </main>

      <Footer data-id="element-409" />
    </div>;
}